import * as React from 'react'

import { inject, observer } from 'mobx-react'

import { ISignature } from '~/client/graph/types.generated'
import UserProfilePreview from '~/client/src/shared/components/UserProfilePreview/UserProfilePreview'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import User from '~/client/src/shared/models/User'
import ProjectMembersStore from '~/client/src/shared/stores/domain/ProjectMembers.store'

import './SignaturePreview.scss'

interface IProps {
  signature: ISignature
  onClick?: () => void
  isEditable?: boolean
  isUserStampEnabled?: boolean
  projectMembersStore?: ProjectMembersStore
}

@inject('projectMembersStore')
@observer
export default class SignaturePreview extends React.Component<IProps> {
  public render() {
    const { signature, onClick, isEditable, isUserStampEnabled } = this.props

    if (!signature?.dataUrl) {
      return null
    }

    const formattedDate = (() => {
      const timestamp = signature?.timestamp
      if (timestamp === null || timestamp === undefined) {
        return null
      }
      const date = new Date(timestamp as any)
      if (isNaN(date.getTime())) {
        return null
      }
      return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    })()

    return (
      <div
        className={`signature-preview col ${isEditable ? 'editable' : ''}`}
        onClick={isEditable ? onClick : undefined}
      >
        <div className="signature-preview-image-container">
          <img
            src={signature.dataUrl}
            alt={Localization.translator.signature}
            className="signature-preview-image"
          />
        </div>
        <div className="signature-preview-info col">
          {isUserStampEnabled && this.renderUserStamp()}
          {formattedDate && (
            <span className="signature-preview-date text small light">
              {formattedDate}
            </span>
          )}
        </div>
      </div>
    )
  }

  private renderUserStamp(): JSX.Element {
    const user = this.getSignerUser()

    if (user) {
      return <UserProfilePreview user={user} isUserNameClickable={true} />
    }

    return null
  }

  private getSignerUser(): User | null {
    const { signature, projectMembersStore } = this.props

    if (signature.userId) {
      return projectMembersStore?.getById(signature.userId) || null
    }

    return null
  }
}
